import React from 'react'
import styles from './ViewerPDF.module.scss'


const ViewerPDF = ({ src, style }) => {
	return !!src && <iframe className={styles.root} {...style && { style }} src={src} title='pdf'/>
}

export default ViewerPDF
